
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modelo/[code]",
      function () {
        return require("private-next-pages/modelo/[code].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modelo/[code]"])
      });
    }
  